import Publication from "./Publication";

export default Publication;
